import { leagueFetch } from "@leagueplatform/league-fetch";
import { API_PATHS } from "common/constants/api";

export const getCommunicationPreferences = async () => {
  const response = await leagueFetch(API_PATHS.COMMUNICATION_PREFERENCES);
  if (!response?.ok) {
    throw new Error(
      `Error Response Code ${response?.status}: ${await response.text()}`
    );
  }
  return response.json();
};
